import React, { FC } from 'react';
import './styles.scss';

export const CandidateProfileHeaderSkeleton: FC = () => {
  return (
    <div className="candidate-profile-header-skeleton">
      <div className="candidate-profile-header-skeleton__avatar pulse-fade" />

      <div className="candidate-profile-header-skeleton__line candidate-profile-header-skeleton__line--xl pulse-fade" />

      <div className="candidate-profile-header-skeleton__line candidate-profile-header-skeleton__line--s pulse-fade" />
    </div>
  );
};
